import React, { useState } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";

import { useGlobalContext } from "../Config";

const Login = ({ handleLogin }) => {
  const { styleProperties } = useGlobalContext();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleUsernameChange = (e) => setUsername(e.target.value);
  const handlePasswordChange = (e) => setPassword(e.target.value);
  const toggleShowPassword = () => setShowPassword(!showPassword);

  const handleSubmit = (e) => {
    e.preventDefault();
    handleLogin(username, password);
  };

  return (
    <div
      className="flex align-items-center justify-content-center min-h-screen"
      style={{ backgroundColor: styleProperties.backgroundColor }}
    >
      <div className="surface-card p-5 shadow-4 border-round-2xl w-full lg:w-4 md:w-6 sm:w-10 m-3 bg-white">
        <div className="text-center mb-5">
          {/* <img
            src={styleProperties.logo}
            alt="Logo"
            height="60"
            className="mb-3"
          /> */}
          <div className="text-900 text-3xl font-medium mb-3">
            {styleProperties.title}
          </div>
          <span className="text-600 font-medium line-height-3">
            Bienvenido, inicia sesión para continuar
          </span>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <span className="p-float-label">
              <InputText
                id="email"
                type="text"
                value={username}
                onChange={handleUsernameChange}
                className="w-full p-inputtext-lg"
                autoComplete="off"
              />
              <label htmlFor="email">Nombre de Usuario</label>
            </span>
          </div>

          <div className="mb-5">
            <div className="p-inputgroup">
              <span className="p-float-label w-full">
                <InputText
                  id="password"
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={handlePasswordChange}
                  className="w-full p-inputtext-lg"
                  autoComplete="off"
                />
                <label htmlFor="password">Contraseña</label>
              </span>
              <Button
                type="button"
                icon={showPassword ? "pi pi-eye" : "pi pi-eye-slash"}
                onClick={toggleShowPassword}
                className="p-button-text p-button-secondary"
              />
            </div>
          </div>

          <Button
            label="Ingresar"
            type="submit"
            className="w-full p-button-lg"
            style={{ backgroundColor: "#007ad9" }}
          />
        </form>
      </div>
    </div>
  );
};

export default Login;
